module.exports = __webpack_public_path__ + "static/media/storage_carousel.fca0f269.jpg";